export default "__VITE_ASSET__Dx0Hg03Q__"